import {makeNewButton} from '/buttons_functions/custom_button_functions.js'

export function quitPlaque(plaque, message, messageCancel, messageConfirm) {
    if(plaque.quitToggle!==null)
        plaque.quitToggle = true;
    
    const plaqueChildren = plaque.children;

    for(let plaqueChild of plaqueChildren) {
        plaqueChild.classList.add('hidden-info');
    }

    const quitPlaqueWindow = document.createElement('div');
    quitPlaqueWindow.setAttribute('id', 'quit-plaque-window');

    const quitText = document.createElement('p');
    quitText.innerText = message;

    const quitButtonGroup = document.createElement('div');
    const quitCancelButton = document.createElement('button');
    const quitConfirmButton = document.createElement('button');

    quitPlaqueWindow.append(quitText);
    quitPlaqueWindow.append(quitButtonGroup);

    quitButtonGroup.append(quitCancelButton);
    quitButtonGroup.append(quitConfirmButton);

    plaque.append(quitPlaqueWindow);

    makeNewButton(quitCancelButton, 'light-black', 'white', messageCancel, 'lighten');
    quitCancelButton.addEventListener('click', () => quitCancel(quitPlaqueWindow, plaqueChildren));
    
    makeNewButton(quitConfirmButton, 'grey', 'black', messageConfirm, 'darken');
    quitConfirmButton.addEventListener('click', () => quitConfirm(plaque));
}

function quitCancel(quitWindow, plaqueChildren) {
    if(plaque.quitToggle!==null)
        plaque.quitToggle = false;
    quitWindow.remove();

    for(let plaqueChild of plaqueChildren) {
        plaqueChild.classList.remove('hidden-info');
    }
}

function quitConfirm(plaque) {
    plaque.remove();
}